import { HORIZON, POLYGON, SEISMIC_SURVEY } from '@core/core/constants'
import type {
  AlgorithmTypeItems,
  Calculation,
  FormDataML,
  MLServiceToUseType,
} from '@core/core/types'
import { AggregationsArr } from '@core/core/types'

import { getDefaultFormData, getMenuItems } from './helpers'
import type { MLModalNavGroup, MLModalNavItem } from './types'

export const mlItems: MLModalNavItem[] = [
  { id: 'algorithm', groupId: 'settings', label: 'Алгоритм' },
  { id: 'calculations', groupId: 'initial', label: 'Объект' },
]

export const mlGroups: MLModalNavGroup[] = [
  { id: 'settings', title: 'Настройка расчета' },
  { id: 'initial', title: 'Входные данные' },
]

const getCalculationName = (index: number) => `Расчёт ${index}`
export const getNextCalculation = (index: number): Calculation => ({
  id: index,
  name: getCalculationName(index),
  params: {
    horizon: { type: HORIZON, entity: null, parameter: null },
    seismicSurvey: { type: SEISMIC_SURVEY, entity: null, parameter: null },
  },
})

const getCalculationScaffold = () => getNextCalculation(1)
export const defaultHorizonExtensionData: FormDataML = {
  type: 'horizonsExtension',
  algorithm: {
    cropSize: 0,
    iterations: 500,
    direction: 'inLine',
    overlap: 1.1,
    aggregation: 'mean',
    postProcessing: 'no',
    mlServiceToUse: 'IAAS',
  },
  calculations: [
    {
      ...getCalculationScaffold(),
      params: {
        seismicSurvey: { entity: null, type: SEISMIC_SURVEY, parameter: null },
        horizon: { entity: null, type: HORIZON, parameter: null },
      },
    },
  ],
}
export const defaultFaultsSeparationData: FormDataML = {
  type: 'faultsSeparation',
  algorithm: {
    cropSize: 0,
    iterations: 2000,
    direction: 'inLine',
    overlap: 0.05,
    aggregation: 'mean',
    stickSelection: false,
    numberOfLeafs: 1,
  },
  calculations: [
    {
      ...getCalculationScaffold(),
      params: {
        seismicSurvey: { entity: null, type: SEISMIC_SURVEY, parameter: null },
      },
    },
  ],
}
export const defaultSeismophationsData: FormDataML = {
  type: 'seismophations',
  algorithm: {
    cropSize: 0,
    iterations: 500,
    direction: 'inLine',
    overlap: 0.5,
    aggregation: 'weighted',
    additionalTraining: true,
  },
  calculations: [
    {
      ...getCalculationScaffold(),
      params: {
        seismicSurvey: { entity: null, type: SEISMIC_SURVEY, parameter: null },
        horizon: { entity: null, type: HORIZON, parameter: null },
        polygon: { entity: null, type: POLYGON },
      },
    },
  ],
}
export const defaultStickSeparationData: FormDataML = {
  type: 'stickSeparation',
  algorithm: {
    numberOfLeafs: 1,
  },
  calculations: [
    {
      ...getCalculationScaffold(),
      params: {
        seismicSurvey: { entity: null, type: SEISMIC_SURVEY, parameter: null },
      },
    },
  ],
}

const defaultAlgorithmType = 'horizonsExtension'
export const defaultFormValue: FormDataML = getDefaultFormData(defaultAlgorithmType)

export const algorithmTypeItems: AlgorithmTypeItems[] = [
  { id: 'horizonsExtension', label: 'Продление горизонтов' },
  // TODO Когда будет реализовано #823602
  // { id: 'faultsSeparation', label: 'Выделение разломов' },
  // { id: 'seismophations', label: 'Выделение сейсмофаций 2D' },
  // { id: 'stickSeparation', label: 'Выделение стиков' },
]
export const cropSizeItems = [
  { id: 0, label: 'auto' },
  { id: 92, label: '92' },
  { id: 128, label: '128' },
  { id: 512, label: '512' },
  { id: 1024, label: '1024' },
]
export const aggregationItems = getMenuItems([...AggregationsArr])

export const booleanItems = [
  { id: 1, label: 'да' },
  { id: 0, label: 'нет' },
]
export const numberOfLeafsItems = [1, 2, 3].map(i => ({ id: i, label: `${i}` }))

export const paramItems = [
  { id: 'amplitude', label: 'Амплитуда' },
  { id: 'twt', label: 'TWT' },
  { id: 'z', label: 'Z' },
  { id: 'frequency', label: 'Частота' },
  { id: 'shift', label: 'Сдвиг' },
]

export const mlServicesItems: MLServiceToUseType[] = ['IAAS', 'PAAS']

export const MIN_OVERLAP = 1
export const MAX_OVERLAP = 5
export const MIN_ITERATIONS = 1
export const MAX_ITERATIONS = 1_000
export const FIRST_CALCULATION_ID = 1
